import DiscourseRoute from "discourse/routes/discourse";
export default class UserPrivateMessagesTags extends DiscourseRoute {}